import * as React from 'react';

export const TableHeader: React.FC = () => {
  return (
    <thead>
      <tr className="bg-beige-light text-center">
        <th className="w-[7.5%] border border-gray px-1.5 py-1.5 md:px-1.25">決算期</th>
        <th className="w-[7.5%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="whitespace-nowrap">四半期</span>
        </th>
        <th className="w-[9.5%] border border-gray px-1.5 py-1.5 md:px-1.25">売上高</th>
        <th className="w-[8.5%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="hidden md:inline">営業利益</span>
          <span className="md:hidden">
            営業
            <br />
            利益
          </span>
        </th>
        <th className="w-[8.5%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="hidden md:inline">経常利益</span>
          <span className="md:hidden">
            経常
            <br />
            利益
          </span>
        </th>
        <th className="w-[8.5%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="whitespace-nowrap">純利益</span>
        </th>
        <th className="w-[8%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="whitespace-nowrap">EPS</span>
        </th>
        <th className="w-[7%] border border-gray px-1.5 py-1.5 md:px-1.25">
          営業
          <br />
          <span className="whitespace-nowrap">利益率</span>
        </th>
        <th className="w-[7%] border border-gray px-1.5 py-1.5 md:px-1.25">
          経常
          <br />
          <span className="whitespace-nowrap">利益率</span>
        </th>
        <th className="w-[7%] border border-gray px-1.5 py-1.5 md:px-1.25">
          売上高
          <br />
          <span className="whitespace-nowrap">前年比</span>
        </th>
        <th className="w-[7%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="hidden md:inline">営業利益</span>
          <span className="md:hidden">営業益</span>
          <br />
          <span className="whitespace-nowrap">前年比</span>
        </th>
        <th className="w-[7%] border border-gray px-1.5 py-1.5 md:px-1.25">
          <span className="hidden md:inline">経常利益</span>
          <span className="md:hidden">経常益</span>
          <br />
          <span className="whitespace-nowrap">前年比</span>
        </th>
        <th className="w-[7%] border border-gray px-1.5 py-1.5 md:px-1.25">
          純利益
          <br />
          <span className="whitespace-nowrap">前年比</span>
        </th>
      </tr>
    </thead>
  );
};
